@import (reference) '../../../../../../constants/spacing.module.less';

.learnMoreLink {
  display: flex;
  align-items: center;
}

.learnMoreIcon {
  margin-left: @space-4;
  height: 12px;
  width: 12px;
}
